import { render, staticRenderFns } from "./ChannelPopup.vue?vue&type=template&id=0b636773&scoped=true"
import script from "./ChannelPopup.vue?vue&type=script&lang=js"
export * from "./ChannelPopup.vue?vue&type=script&lang=js"
import style0 from "./ChannelPopup.vue?vue&type=style&index=0&id=0b636773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b636773",
  null
  
)

export default component.exports